import moment from "moment";
import { InsuranceTypesType,InsuranceReceiverType,InsurancePayerType,PostOfficeType} from "../types";

export type ErrorObjectType = {
  AdditionalReference: string;
  AdditionalReferenceObjectName: string;
  Reference: string;
  ReferenceObjectName: string;
  ErrorText: string;
  ObjectName: string;
  Transaction: string;
};

export type SubmitResponseType = {
  StatusCode: number;
  Message: string;
  Success: boolean;
  UserMessage: string;
  Error: ErrorObjectType[];
};

export type ClaimDownloadParams = {
  clinicId: number;
  claims: { encounterId: number }[];
  isProduction: boolean;
  type: "SUBMISSION" | "RESUBMISSION";
  postOfficeId:number
};

export type ClaimSubmissionParams = {
  clinicId: number;
  isProduction: boolean;
  claims: {encounterId: number}[];
  type: "Submission" | "Resubmission" | "";
  postOfficeId:number
};

export type ClaimSearchSubmitType = {
  fromDate:string,
  toDate:string,
  insuranceType:InsuranceTypesType | null,
  receiver:InsuranceReceiverType | null,
  payer:InsurancePayerType | null,
  postoffice:PostOfficeType | null,
  all:boolean
}

export const initialData:ClaimSearchSubmitType = {
  fromDate:moment().format("yyyy-MM-DD"),
  toDate:moment().format("yyyy-MM-DD"),
  insuranceType: null,
  receiver:null,
  payer: null,
  postoffice:null,
  all:true
}